import Cookies from "js-cookie";
import { disableBodyScroll, enableBodyScroll } from "body-scroll-lock";

let cookieModalEl;
let cookieModalScrollContainer;
let cookieAcceptEl;
let cookieRejectEl;

let privacySettingsEl;
let privacySettingsNoJsEl;
let privacySettingsAcceptRadio;
let privacySettingsRejectRadio;

const cookieName = 'cookie-prefs';
const cookieAcceptValue = 'accept';
const cookieRejectValue = 'reject';
const cookieExpireDays = 90;

const answerEndpoint = '/privacy-response/';

const gtmCode = 'GTM-MBDH3LRK';

const suppressedPaths = [
    '/terms-and-conditions/',
    '/privacy-policy/',
    '/cookie-policy/',
    '/privacy-settings/',
];

// Init dataLayer
window.dataLayer = window.dataLayer || [];
const gtag = function gtag() {
    window.dataLayer.push(arguments);
}

const setAcceptCookie = () => {
    Cookies.set(cookieName, cookieAcceptValue, {
        expires: cookieExpireDays,
        sameSite: 'strict',
    });
}

const setRejectCookie = () => {
    Cookies.set(cookieName, cookieRejectValue, {
        expires: cookieExpireDays,
        sameSite: 'strict',
    });
}

const hasCookie = () => {
    return Cookies.get(cookieName) !== undefined;
}

const cookiesAccepted = () => {
    return Cookies.get(cookieName) === cookieAcceptValue;
}


const updateState = (state, selector, property) => {
    const els = document.querySelectorAll(selector);

    els.forEach((el) => {
        const styles = el.dataset[property];
        const classes = JSON.parse(styles || "{}");

        const openArr = classes.open.split(" ");
        const closedArr = classes.closed.split(" ");

        if (state === "open") {
            el.classList.add(...openArr);
            el.classList.remove(...closedArr);
        } else if (state === "closed") {
            el.classList.add(...closedArr);
            el.classList.remove(...openArr);
        }
    });
};

const wireAcceptClick = () => {
    cookieAcceptEl.addEventListener("click", (event) => {
        event.preventDefault();
        setAcceptCookie();
        addDataLayerAcceptEvent();
        addGTMScript();
        hideCookieModal();
        logAnswer(true);
    });
};

const wireRejectClick = () => {
    cookieRejectEl.addEventListener("click", (event) => {
        event.preventDefault();
        setRejectCookie();
        hideCookieModal();
        logAnswer(false);
    });
};

const logAnswer = ( hasAccepted ) => {
    const request = new XMLHttpRequest();
    const data = 'agree=' + ( hasAccepted ? '1' : '0' );
    request.open( 'POST', answerEndpoint, true );
    request.setRequestHeader( 'Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8' );
    request.send( data );
};

const handlePageLoad = () => {
    if ( hasCookie() ) {
        // Has a cookie
        if ( cookiesAccepted() ) {
            // Accepted! Render out GTM
            addGTMScript();
        } else {
            // Rejected! Do nothing
        }
    } else if ( suppressedPaths.indexOf( document.location.pathname ) === -1 ) {
        // No cookie, so show the popup if it's not in the list
        // of suppressed paths
        showCookieModal();
    }
};

const showCookieModal = () => {
    // Delay showing modal to allow the fade-in css transition to work.
    setTimeout(() => {
        updateState("open", "[data-consent-modifiers]", "consentModifiers");
        disableBodyScroll(cookieModalScrollContainer);
    }, 100);
};

const hideCookieModal = () => {
    updateState("closed", "[data-consent-modifiers]", "consentModifiers");
    enableBodyScroll(cookieModalScrollContainer);
};

const addDataLayerAcceptEvent = () => {
    gtag( 'event', 'cookie_accepted' );
};

const addGTMScript = () => {
    if ( window.analyticsEnabled ) {
        writeConsentModeAcceptData();
        initGTM( window, document, 'script', 'dataLayer', gtmCode );
    } else {
        console.log( 'Rendering GTM (but Analytics Disabled)' );
    }
};

const writeConsentModeAcceptData = function writeConsentModeData() {
    gtag( 'consent', 'update', {
        ad_storage: 'granted',
        ad_user_data: 'granted',
        ad_personalization: 'granted',
        analytics_storage: 'granted',
        functionality_storage: 'granted',
        personalization_storage: 'granted',
        security_storage: 'granted',
    } );
};

const initGTM = ( w, d, s, l, i ) => {
    /* eslint-disable */
    w[l] = w[l] || [];
    w[l].push({
        'gtm.start': new Date().getTime(),
        event:'gtm.js'
    } );
    var f = d.getElementsByTagName(s)[0];
    var j = d.createElement(s);
    var dl = l !== 'dataLayer' ? '&l=' + l : '';
    j.async = true;
    j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
    f.parentNode.insertBefore(j, f);
    /* eslint-enable */
};

const initPrivacySettingsState = () => {
    // - Set the initial checkbox checked status
    let acceptState = false;
    let rejectState = false;
    if ( hasCookie() ) {
        if ( cookiesAccepted() ) {
            acceptState = true;
        } else {
            rejectState = true;
        }
    }
    privacySettingsAcceptRadio.checked = acceptState;
    privacySettingsRejectRadio.checked = rejectState;

    // - Show the privacy settings
    // - Hide the "nojs" message
    privacySettingsNoJsEl.classList.add( 'is-hidden' );
    privacySettingsEl.classList.remove( 'is-hidden' );
};

const wirePrivacySettingsClicks = () => {
    privacySettingsAcceptRadio.addEventListener( 'click', () => {
        setAcceptCookie();
    } );

    privacySettingsRejectRadio.addEventListener( 'click', () => {
        setRejectCookie();
    } );
};

const ConsentModal = () => {
    cookieModalEl = document.querySelector("[data-consent-modal]");
    if (cookieModalEl) {
        cookieModalScrollContainer = cookieModalEl.firstElementChild;
        cookieAcceptEl = cookieModalEl.querySelector("[data-consent-accept]");
        cookieRejectEl = cookieModalEl.querySelector("[data-consent-reject]");
        wireAcceptClick();
        wireRejectClick();
        handlePageLoad();
    }

    privacySettingsEl = document.querySelector("[data-privacy-settings]");
    if (privacySettingsEl) {
        privacySettingsAcceptRadio = document.querySelector("[data-privacy-settings-accept]");
        privacySettingsRejectRadio = document.querySelector("[data-privacy-settings-reject]");
        privacySettingsNoJsEl = document.querySelector("[data-privacy-settings-nojs]");
        wirePrivacySettingsClicks();
        initPrivacySettingsState();
    }
};

export default ConsentModal;
